/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createAppPassword'

export { $nsid }

/** Create an App Password. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({ name: l.string(), privileged: l.optional(l.boolean()) }),
  l.payload('application/json', l.ref<AppPassword>((() => appPassword) as any)),
  ['AccountTakedown'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

type AppPassword = {
  $type?: 'com.atproto.server.createAppPassword#appPassword'
  name: string
  password: string
  createdAt: l.DatetimeString
  privileged?: boolean
}

export type { AppPassword }

const appPassword = l.typedObject<AppPassword>(
  $nsid,
  'appPassword',
  l.object({
    name: l.string(),
    password: l.string(),
    createdAt: l.string({ format: 'datetime' }),
    privileged: l.optional(l.boolean()),
  }),
)

export { appPassword }
